import Icon from '@/components/snippets/icon/icon'
import { FilterSort } from 'libs/searchspring/components/collection/filters/FilterSort'
import { ProductCount } from 'libs/searchspring/components/collection/filters/ProductCount'
import { useFilters } from 'libs/searchspring/hooks/useFilters'

export const CollectionToolbar = () => {
  const {
    handleOpenFilters,
    activeFilters
  } = useFilters()

  const activeFilterCount = activeFilters?.size

  const handleFilterOpen = () => {
    handleOpenFilters()
    document.querySelector('x-modal[data-id="filters"]')?.handleToggle()
  }

  return (
    <div className="collection-toolbar sticky top-header-adapt grid grid-cols-3 lg:flex items-center justify-between gap-x-gutter lg:gap-x-1.5 w-full h-[60px] px-margin bg-secondary border-b border-neutral-light z-40 has-[[data-ui=visible]]:lg-max:z-60 transition-all">
      <div className={'lg:grow'}>
        <button
          id="toggle-filters"
          className={'flex items-center gap-x-0.5 link-fade'}
          onClick={handleFilterOpen}
          aria-label="Toggle Filters"
        >
          <div class="w-[17px] h-[12px] children:size-full">
            <Icon id="filter" />
          </div>
          <span className="filters__toggle before:content-show lg-max:before:hidden text-xxs lg:text-xs font-ext font-bold uppercase">
            Filters<span className="lg:hidden">{activeFilterCount > 0 ? ` (${activeFilterCount})` : ''}</span>
          </span>
        </button>
      </div>

      <div className="lg-max:justify-self-center">
        <ProductCount />
      </div>

      <div className="hidden lg:block h-[20px] border-r border-neutral-light"></div>

      <div className={'lg-max:justify-self-end'}>
        <FilterSort />
      </div>
    </div>
  )
}
